import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { createPortal } from "react-dom";
import { Button } from "react-bootstrap";

export default function PdfFullscreen({ pdf, nome, fullscreen, setFullscreen }) {
  
  // Função para disparar o download
  const downloadArquivo = () => {
    const link = document.createElement('a');
    link.href = pdf;
    link.download = nome || "arquivo";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const view = (
    <AnimatePresence>
      {fullscreen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          style={{
            position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
            backgroundColor: 'rgba(15, 23, 42, 0.98)', zIndex: 99999,
            display: 'flex', flexDirection: 'column', padding: '20px'
          }}
        >
          {/* Header com Nome e Botões */}
          <div style={{ 
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            marginBottom: '16px', color: '#fff', padding: '0 8px'
          }}>
            <h5 style={{ 
              margin: 0, 
              overflow: 'hidden', 
              textOverflow: 'ellipsis', 
              whiteSpace: 'nowrap', 
              maxWidth: '60%',
              fontWeight: '700',
              fontSize: '1.2rem',
              color: '#ffffff'
            }}>
              {nome}
            </h5>
            
            <div style={{ display: 'flex', gap: '12px' }}>
              {/* Botão de Download em Gradiente Vermelho */}
              <Button 
                style={{
                  background: 'linear-gradient(135deg, #8b0000 0%, #b31d1d 100%)',
                  border: 'none',
                  borderRadius: '10px',
                  fontWeight: '600',
                  padding: '8px 18px',
                  boxShadow: '0 4px 12px rgba(179, 29, 29, 0.3)'
                }} 
                onClick={downloadArquivo}
              >
                <i className="bi bi-download me-1"></i> Download
              </Button>

              {/* Botão Fechar */}
              <Button 
                variant="outline-light"
                style={{
                  borderRadius: '10px',
                  fontWeight: '600',
                  padding: '8px 18px',
                  borderColor: 'rgba(255, 255, 255, 0.2)'
                }} 
                onClick={() => setFullscreen(false)}
              >
                <i className="bi bi-x-lg me-1"></i> Fechar
              </Button>
            </div>
          </div>

          {/* Área do Conteúdo / Visualizador */}
          <div style={{ 
            flexGrow: 1, 
            backgroundColor: '#ffffff', 
            borderRadius: '16px', 
            overflow: 'hidden',
            boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
            border: '1px solid rgba(255, 255, 255, 0.1)'
          }}>
            {pdf ? (
              <iframe
                src={pdf}
                width="100%"
                height="100%"
                style={{ border: 'none' }}
                title="Visualizador"
              />
            ) : (
              <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100%',
                color: '#64748b',
                fontWeight: '600'
              }}>
                Carregando arquivo...
              </div>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );

  return typeof document !== "undefined" ? createPortal(view, document.body) : null;
}